import { __awaiter } from "tslib";
import { EventService, } from '@office-start/metaos-hub-sdk';
import { logError, logPerformanceWithParams, } from '@office-start/telemetry-service';
export class AppHostAuthenticationService extends EventService {
    constructor(accessTokenResponseFunction, user, authRedirectUrl) {
        super();
        this.acquireToken = (resource, claims, silent) => __awaiter(this, void 0, void 0, function* () {
            if (!resource) {
                throw new Error('Resource URL not provided');
            }
            const start = Date.now();
            const response = yield this.accessTokenResponseFunction('MetaOS', false, resource, undefined, undefined, claims, silent, {
                category: 'MetaOSApp',
            });
            const duration = Date.now() - start;
            logPerformanceWithParams({
                eventName: "AppHost_Authentication_Acquire_Token" /* KnownPerfInstrumentationEvents.AppHostAuthenticationAcquireToken */,
                latency: duration,
                instrumentationParams: {
                    requestMethod: "AppHost_Authentication_Acquire_Token" /* KnownPerfInstrumentationEvents.AppHostAuthenticationAcquireToken */,
                    success: !!response.success,
                },
            });
            if (response.success && response.token) {
                return { token: response.token };
            }
            logError({
                eventName: 'Access_Token_Response',
                errorType: 'GetOfficeToken_Error',
                message: 'Unable to get access token. Access token response error',
                debugInfo: `acquireToken for resource: ${resource} failed for MOSAppHost. claims: ${claims}, isSilent: ${silent}`,
            });
            throw new Error('Unable to get access token');
        });
        this.getUser = () => __awaiter(this, void 0, void 0, function* () {
            return Object.assign({}, this.user);
        });
        this.accessTokenResponseFunction = accessTokenResponseFunction;
        this.user = user;
        this.authRedirectUrl = authRedirectUrl;
    }
    get externalAuthRedirectUrl() {
        return this.authRedirectUrl;
    }
}
//# sourceMappingURL=AppHostAuthenticationService.js.map